// Lista de referência das tags disponíveis para uso nos templates .docx de contrato.
// Cada tag digitada no documento entre colchetes (ex: [PFNome]) será substituída
// pela informação real do contrato quando o documento for gerado.

export const TAGS_TEMPLATE_CONTRATO = [
  // ── Imóvel ───────────────────────────────────────────────────────────────
  {
    categoria: "Imóvel",
    tag: "IdImovel",
    descricao: "Id do Imóvel do ImobGest – Tabela Imóveis",
    exemplo: "482",
    uso: "Referente ao imóvel de código [IdImovel].",
  },
  {
    categoria: "Imóvel",
    tag: "EnderecoImovel",
    descricao: "Vir do cadastro de imóvel para manter histórico",
    exemplo: "Rua das Flores, 123 - Centro - São Paulo/SP - CEP 01310-100",
    uso: "O imóvel objeto deste contrato está localizado em [EnderecoImovel].",
  },
  {
    categoria: "Imóvel",
    tag: "AreaImovel",
    descricao: "Área do imóvel em m² (vir do cadastro de imóvel para manter histórico)",
    exemplo: "150,00 m²",
    uso: "O imóvel possui área total de [AreaImovel].",
  },
  {
    categoria: "Imóvel",
    tag: "AreaConstruida",
    descricao: "Área construída em m² (vir do cadastro de imóvel para manter histórico)",
    exemplo: "120,50 m²",
    uso: "com área construída de [AreaConstruida].",
  },

  // ── Proposta / Contrato ──────────────────────────────────────────────────
  {
    categoria: "Proposta / Contrato",
    tag: "TipoLocacao",
    descricao: "Tipo da Locação (Residencial|Não Residencial)",
    exemplo: "Residencial",
    uso: "O presente contrato é de locação [TipoLocacao].",
  },
  {
    categoria: "Proposta / Contrato",
    tag: "Locataria",
    descricao: "Verificar relacionamento (inquilino)",
    exemplo: "João da Silva Santos",
    uso: "e de outro lado [Locataria], doravante denominado LOCATÁRIO.",
  },
  { categoria: "Proposta / Contrato", tag: "Prazo", descricao: "Número de meses", exemplo: "30", uso: "O prazo de locação será de [Prazo] meses," },
  { categoria: "Proposta / Contrato", tag: "DataInicio", descricao: "Data início do contrato", exemplo: "01/08/2026", uso: "com início em [DataInicio]" },
  { categoria: "Proposta / Contrato", tag: "DataFim", descricao: "Data final do contrato", exemplo: "31/01/2029", uso: "e término em [DataFim]." },
  {
    categoria: "Proposta / Contrato",
    tag: "vAluguelMensal",
    descricao: "Valor do aluguel mensal",
    exemplo: "R$ 3.500,00",
    uso: "O valor mensal do aluguel será de [vAluguelMensal],",
  },
  {
    categoria: "Proposta / Contrato",
    tag: "vCondominio",
    descricao: "Valor do condomínio",
    exemplo: "R$ 650,00",
    uso: "acrescido do condomínio de [vCondominio],",
  },
  { categoria: "Proposta / Contrato", tag: "vIPTU", descricao: "Valor do IPTU", exemplo: "R$ 180,00", uso: "IPTU de [vIPTU]," },
  { categoria: "Proposta / Contrato", tag: "vAguaEsgoto", descricao: "Valor água e esgoto", exemplo: "R$ 90,00", uso: "água e esgoto de [vAguaEsgoto]," },
  { categoria: "Proposta / Contrato", tag: "vEnergia", descricao: "Valor energia", exemplo: "R$ 220,00", uso: "energia elétrica de [vEnergia]." },
  { categoria: "Proposta / Contrato", tag: "vDesconto", descricao: "Valor desconto", exemplo: "R$ 200,00", uso: "Será concedido desconto de [vDesconto]" },
  {
    categoria: "Proposta / Contrato",
    tag: "DescrDesconto",
    descricao: "Descrição desconto",
    exemplo: "Desconto de carência no primeiro mês",
    uso: "referente a [DescrDesconto].",
  },
  { categoria: "Proposta / Contrato", tag: "vInternet", descricao: "Valor internet", exemplo: "R$ 120,00", uso: "internet de [vInternet]" },
  { categoria: "Proposta / Contrato", tag: "vTotem", descricao: "Valor totem", exemplo: "R$ 300,00", uso: "e totem de [vTotem]." },
  { categoria: "Proposta / Contrato", tag: "Carencia", descricao: "Período de carência", exemplo: "30 dias", uso: "com carência de [Carencia]." },
  { categoria: "Proposta / Contrato", tag: "MesReajuste", descricao: "Mês base reajuste", exemplo: "08", uso: "O reajuste ocorrerá no mês [MesReajuste]" },
  { categoria: "Proposta / Contrato", tag: "AnoReajuste", descricao: "Ano base reajuste", exemplo: "2026", uso: "a partir do ano de [AnoReajuste]," },
  { categoria: "Proposta / Contrato", tag: "IndiceReajuste", descricao: "Descrição do índice", exemplo: "IGPM", uso: "com base no índice [IndiceReajuste]." },
  {
    categoria: "Proposta / Contrato",
    tag: "DiaVencimento",
    descricao: "Dia do vencimento do aluguel",
    exemplo: "10",
    uso: "com vencimento todo dia [DiaVencimento] de cada mês.",
  },
  {
    categoria: "Proposta / Contrato",
    tag: "Garantia",
    descricao: "Caução 3 aluguéis | Seguro Fiança | Fiador | Título de Capitalização | Sem Garantias",
    exemplo: "Fiador",
    uso: "A garantia locatícia adotada será [Garantia].",
  },
  { categoria: "Proposta / Contrato", tag: "vCaucao", descricao: "Valor caução", exemplo: "R$ 10.500,00", uso: "no valor de caução de [vCaucao]." },
  {
    categoria: "Proposta / Contrato",
    tag: "Boleto",
    descricao: "Boleto (Sim/Não), com quantidade e valor quando Sim",
    exemplo: "Sim — 12 boletos de R$ 3,50",
    uso: "Pagamento por boleto: [Boleto].",
  },
  { categoria: "Proposta / Contrato", tag: "BoletoQuantidade", descricao: "Quantidade de boletos", exemplo: "12", uso: "em [BoletoQuantidade] boletos" },
  { categoria: "Proposta / Contrato", tag: "BoletoValor", descricao: "Valor do boleto", exemplo: "R$ 3,50", uso: "no valor de [BoletoValor] cada" },
  {
    categoria: "Proposta / Contrato",
    tag: "Seguradora",
    descricao: "Nome/razão social da seguradora — atalho só com o nome; demais dados na categoria Seguradora",
    exemplo: "Seguradora Exemplo Fiança Ltda",
    uso: "contratado junto à [Seguradora].",
  },
  {
    categoria: "Proposta / Contrato",
    tag: "Fiador",
    descricao: "Nome do fiador — atalho só com o nome; demais dados na categoria Fiador",
    exemplo: "Carlos Eduardo Pereira",
    uso: "tendo como fiador [Fiador].",
  },

  // ── Locadora ─────────────────────────────────────────────────────────────
  // Dados da locadora (proprietária do imóvel), ficha PF ou PJ vinculada à proposta.
  {
    categoria: "Locadora",
    tag: "Locadora",
    descricao: "Nome/razão social da locadora",
    exemplo: "Maria Aparecida Souza",
    uso: "De um lado [Locadora], doravante denominada LOCADORA,",
  },
  { categoria: "Locadora", tag: "LocadoraTipoPessoa", descricao: "PJ|PF", exemplo: "PF", uso: "Pessoa: [LocadoraTipoPessoa]." },
  {
    categoria: "Locadora",
    tag: "LocadoraCPF",
    descricao: "CPF da locadora (quando pessoa física)",
    exemplo: "123.456.789-00",
    uso: "portadora do CPF nº [LocadoraCPF],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraCNPJ",
    descricao: "CNPJ da locadora (quando pessoa jurídica)",
    exemplo: "12.345.678/0001-90",
    uso: "inscrita no CNPJ sob o nº [LocadoraCNPJ],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraEndereco",
    descricao: "Endereço da locadora",
    exemplo: "Rua das Flores, 123 - Centro - São Paulo/SP - CEP 01310-100",
    uso: "residente/sediada em [LocadoraEndereco],",
  },
  { categoria: "Locadora", tag: "LocadoraTelefone", descricao: "Telefone da locadora", exemplo: "(11) 98765-4321", uso: "telefone [LocadoraTelefone]," },
  {
    categoria: "Locadora",
    tag: "LocadoraEmail",
    descricao: 'E-mails separados por "," ou ";"',
    exemplo: "maria.souza@emailexemplo.com.br",
    uso: "e-mail [LocadoraEmail].",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraRepresentante",
    descricao: "Nome do representante legal que assina pela locadora (quando PJ)",
    exemplo: "Roberto Almeida Costa",
    uso: "neste ato representada por [LocadoraRepresentante],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraRepresentanteDTNascimento",
    descricao: "Data de nascimento do representante legal da locadora (quando PJ)",
    exemplo: "22/09/1985",
    uso: "nascido em [LocadoraRepresentanteDTNascimento],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraRepresentanteNacionalidade",
    descricao: "Nacionalidade do representante legal da locadora (quando PJ)",
    exemplo: "Brasileira",
    uso: "de nacionalidade [LocadoraRepresentanteNacionalidade],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraRepresentanteNaturalidade",
    descricao: "Naturalidade do representante legal da locadora (quando PJ)",
    exemplo: "São Paulo/SP",
    uso: "natural de [LocadoraRepresentanteNaturalidade],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraRepresentanteEstadoCivil",
    descricao: "Casado|Solteiro|Viúvo do representante legal da locadora (quando PJ)",
    exemplo: "Casado",
    uso: "estado civil [LocadoraRepresentanteEstadoCivil],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraRepresentanteRegimeCasamento",
    descricao: "Regime de casamento do representante legal da locadora (quando PJ)",
    exemplo: "Comunhão parcial de bens",
    uso: "sob o regime de [LocadoraRepresentanteRegimeCasamento],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraRepresentanteProfissao",
    descricao: "Profissão do representante legal da locadora (quando PJ)",
    exemplo: "Empresário",
    uso: "profissão [LocadoraRepresentanteProfissao],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraRepresentanteCPF",
    descricao: "CPF do representante legal da locadora (quando PJ)",
    exemplo: "123.456.789-00",
    uso: "inscrito no CPF sob o nº [LocadoraRepresentanteCPF],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraRepresentanteRG",
    descricao: "RG do representante legal da locadora (quando PJ)",
    exemplo: "12.345.678-9",
    uso: "portador da Cédula de Identidade RG nº [LocadoraRepresentanteRG]",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraRepresentanteRGOrgao",
    descricao: "Órgão emissor do RG do representante legal da locadora (quando PJ)",
    exemplo: "SSP/SP",
    uso: "–[LocadoraRepresentanteRGOrgao]",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraRepresentanteRGEmissao",
    descricao: "Data de emissão do RG do representante legal da locadora (quando PJ)",
    exemplo: "05/03/2005",
    uso: "em [LocadoraRepresentanteRGEmissao],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraRepresentanteEndereco",
    descricao: "Endereço residencial do representante legal da locadora (quando PJ)",
    exemplo: "Rua das Flores, 123 - Centro - São Paulo/SP - CEP 01310-100",
    uso: "residente em [LocadoraRepresentanteEndereco].",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraRepresentanteTelefone",
    descricao: "Telefone residencial ou celular do representante legal da locadora (quando PJ)",
    exemplo: "(11) 98765-4321",
    uso: "telefone [LocadoraRepresentanteTelefone],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraRepresentanteEmail",
    descricao: "E-mail do representante legal da locadora (quando PJ)",
    exemplo: "roberto.costa@emailexemplo.com.br",
    uso: "e-mail [LocadoraRepresentanteEmail].",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraConjuge",
    descricao: "Nome do cônjuge da locadora (PF)",
    exemplo: "Ana Paula Ferreira",
    uso: "casado com [LocadoraConjuge],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraConjugeDtNascimento",
    descricao: "Data de nascimento do cônjuge da locadora",
    exemplo: "14/11/1987",
    uso: "nascida em [LocadoraConjugeDtNascimento],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraConjugeNacionalidade",
    descricao: "Nacionalidade do cônjuge da locadora",
    exemplo: "Brasileira",
    uso: "nacionalidade [LocadoraConjugeNacionalidade],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraConjugeNaturalidade",
    descricao: "Naturalidade do cônjuge da locadora",
    exemplo: "Campinas/SP",
    uso: "natural de [LocadoraConjugeNaturalidade],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraConjugeProfissao",
    descricao: "Profissão do cônjuge da locadora",
    exemplo: "Advogada",
    uso: "profissão [LocadoraConjugeProfissao],",
  },
  { categoria: "Locadora", tag: "LocadoraConjugeCPF", descricao: "CPF do cônjuge da locadora", exemplo: "987.654.321-00", uso: "CPF nº [LocadoraConjugeCPF]" },
  { categoria: "Locadora", tag: "LocadoraConjugeRG", descricao: "RG do cônjuge da locadora", exemplo: "23.456.789-0", uso: "RG nº [LocadoraConjugeRG]," },
  {
    categoria: "Locadora",
    tag: "LocadoraConjugeRGOrgao",
    descricao: "Órgão emissor do RG do cônjuge da locadora",
    exemplo: "SSP/SP",
    uso: "expedido por [LocadoraConjugeRGOrgao]",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraConjugeRGEmissao",
    descricao: "Data de emissão do RG do cônjuge da locadora",
    exemplo: "18/07/2007",
    uso: "em [LocadoraConjugeRGEmissao],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraConjugeTelefone",
    descricao: "Telefone do cônjuge da locadora",
    exemplo: "(11) 91234-5678",
    uso: "telefone [LocadoraConjugeTelefone],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraConjugeEmail",
    descricao: "E-mail do cônjuge da locadora",
    exemplo: "ana.ferreira@emailexemplo.com.br",
    uso: "e-mail [LocadoraConjugeEmail].",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraConjugeEmpresaTrabalha",
    descricao: "Empresa onde o cônjuge da locadora trabalha",
    exemplo: "Escritório de Advocacia Exemplo",
    uso: "empregada na empresa [LocadoraConjugeEmpresaTrabalha],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraConjugeEmpresaEndereco",
    descricao: "Endereço da empresa do cônjuge da locadora",
    exemplo: "Rua dos Advogados, 200 - São Paulo/SP - CEP 01452-000",
    uso: "localizada em [LocadoraConjugeEmpresaEndereco],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraConjugeEmpresaDtAdmissao",
    descricao: "Data de admissão do cônjuge da locadora",
    exemplo: "10/06/2015",
    uso: "desde [LocadoraConjugeEmpresaDtAdmissao],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraConjugeEmpresaCargo",
    descricao: "Cargo do cônjuge da locadora",
    exemplo: "Advogada Sênior",
    uso: "no cargo de [LocadoraConjugeEmpresaCargo],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraConjugeEmpresaSalario",
    descricao: "Salário do cônjuge da locadora",
    exemplo: "R$ 8.000,00",
    uso: "com salário de [LocadoraConjugeEmpresaSalario].",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraConjugeEmpresaOutroRendimento",
    descricao: "Outros rendimentos do cônjuge da locadora",
    exemplo: "Não",
    uso: "Possui outros rendimentos: [LocadoraConjugeEmpresaOutroRendimento].",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraConjugeEmpresaOutroRendimentoValor",
    descricao: "Valor dos outros rendimentos do cônjuge da locadora",
    exemplo: "R$ 0,00",
    uso: "no valor de [LocadoraConjugeEmpresaOutroRendimentoValor],",
  },
  {
    categoria: "Locadora",
    tag: "LocadoraConjugeEmpresaOutroRendimentoProvem",
    descricao: "Origem dos outros rendimentos do cônjuge da locadora",
    exemplo: "—",
    uso: "provenientes de [LocadoraConjugeEmpresaOutroRendimentoProvem].",
  },

  // ── Locatária ────────────────────────────────────────────────────────────
  { categoria: "Locatária", tag: "LocatariaTipoPessoa", descricao: "PJ|PF", exemplo: "PJ", uso: "Pessoa: [LocatariaTipoPessoa]." },
  {
    categoria: "Locatária",
    tag: "LocatariaEmail",
    descricao: 'E-mails da locatária separados por "," ou ";"',
    exemplo: "contato@empresaexemplo.com.br",
    uso: "contato via e-mail: [LocatariaEmail].",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaRazaoSocial",
    descricao: "Razão social da locatária (PJ)",
    exemplo: "Comércio de Materiais Exemplo Ltda",
    uso: "a empresa [LocatariaRazaoSocial],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaCNPJ",
    descricao: "CNPJ da locatária (PJ)",
    exemplo: "12.345.678/0001-90",
    uso: "inscrita no CNPJ sob o nº [LocatariaCNPJ],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaEndereco",
    descricao: "Endereço da locatária PJ (ver padrão de separação das informações do endereço)",
    exemplo: "Av. Paulista, 1000 - Sala 12 - Bela Vista - São Paulo/SP - CEP 01310-100",
    uso: "com sede em [LocatariaEndereco],",
  },
  { categoria: "Locatária", tag: "LocatariaTelefone", descricao: "Telefone da locatária PJ", exemplo: "(11) 3456-7890", uso: "telefone [LocatariaTelefone]," },
  {
    categoria: "Locatária",
    tag: "LocatariaDataConstituicao",
    descricao: "Data de constituição da locatária (PJ)",
    exemplo: "12/04/2010",
    uso: "constituída em [LocatariaDataConstituicao],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaCapitalSocial",
    descricao: "Capital social da locatária (PJ)",
    exemplo: "R$ 100.000,00",
    uso: "com capital social de [LocatariaCapitalSocial].",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaEnderecoFilial",
    descricao: "Endereço da filial da locatária (PJ)",
    exemplo: "Rua Comercial, 45 - Vila Industrial - Campinas/SP - CEP 13030-000",
    uso: "com filial em [LocatariaEnderecoFilial],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaTelefoneFilial",
    descricao: "Telefone da filial da locatária (PJ)",
    exemplo: "(19) 3234-5678",
    uso: "telefone da filial [LocatariaTelefoneFilial],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaRamoAtividade",
    descricao: "Ramo de atividade da locatária (PJ)",
    exemplo: "Comércio varejista de materiais de construção",
    uso: "atuante no ramo de [LocatariaRamoAtividade],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaProdutosServicos",
    descricao: "Produtos e serviços da locatária (PJ)",
    exemplo: "Venda de materiais de construção e ferragens",
    uso: "com produtos e serviços: [LocatariaProdutosServicos].",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaQtdeFuncionarios",
    descricao: "Número de funcionários da locatária (PJ)",
    exemplo: "18",
    uso: "possui [LocatariaQtdeFuncionarios] funcionários",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaFaturamentoMensal",
    descricao: "Faturamento mensal da locatária (PJ)",
    exemplo: "R$ 80.000,00",
    uso: "com faturamento mensal de [LocatariaFaturamentoMensal].",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaNome",
    descricao: "Nome da locatária (PF)",
    exemplo: "João da Silva Santos",
    uso: "neste ato denominado LOCATÁRIO [LocatariaNome],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaDTNascimento",
    descricao: "Data de nascimento da locatária (PF)",
    exemplo: "22/09/1985",
    uso: "nascido em [LocatariaDTNascimento],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaNacionalidade",
    descricao: "Nacionalidade da locatária (PF)",
    exemplo: "Brasileira",
    uso: "de nacionalidade [LocatariaNacionalidade],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaNaturalidade",
    descricao: "Naturalidade da locatária (PF)",
    exemplo: "São Paulo/SP",
    uso: "natural de [LocatariaNaturalidade],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaEstadoCivil",
    descricao: "Casado|Solteiro|Viúvo (PF)",
    exemplo: "Casado",
    uso: "estado civil [LocatariaEstadoCivil],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaRegimeCasamento",
    descricao: "Regime de casamento da locatária (PF)",
    exemplo: "Comunhão parcial de bens",
    uso: "sob o regime de [LocatariaRegimeCasamento],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaProfissao",
    descricao: "Profissão da locatária (PF)",
    exemplo: "Engenheiro Civil",
    uso: "profissão [LocatariaProfissao],",
  },
  { categoria: "Locatária", tag: "LocatariaCPF", descricao: "CPF da locatária (PF)", exemplo: "123.456.789-00", uso: "portador do CPF nº [LocatariaCPF]" },
  { categoria: "Locatária", tag: "LocatariaRG", descricao: "RG da locatária (PF)", exemplo: "12.345.678-9", uso: "e RG nº [LocatariaRG]," },
  {
    categoria: "Locatária",
    tag: "LocatariaRGOrgao",
    descricao: "Órgão emissor do RG da locatária (PF)",
    exemplo: "SSP/SP",
    uso: "expedido por [LocatariaRGOrgao]",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaRGEmissao",
    descricao: "Data de emissão do RG da locatária (PF)",
    exemplo: "05/03/2005",
    uso: "em [LocatariaRGEmissao],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaPFEndereco",
    descricao: "Endereço residencial da locatária (PF)",
    exemplo: "Rua das Flores, 123 - Centro - São Paulo/SP - CEP 01310-100",
    uso: "residente em [LocatariaPFEndereco],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaPFTelefone",
    descricao: "Telefone da locatária (PF)",
    exemplo: "(11) 98765-4321",
    uso: "telefone [LocatariaPFTelefone],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaPFEmail",
    descricao: 'E-mails da locatária (PF) separados por "," ou ";"',
    exemplo: "joao.silva@emailexemplo.com.br",
    uso: "e-mail [LocatariaPFEmail].",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaEmpresaTrabalha",
    descricao: "Empresa onde a locatária (PF) trabalha",
    exemplo: "Construtora Exemplo Ltda",
    uso: "empregado na empresa [LocatariaEmpresaTrabalha],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaEmpresaEndereco",
    descricao: "Endereço da empresa onde a locatária (PF) trabalha",
    exemplo: "Av. Paulista, 1000 - São Paulo/SP - CEP 01310-100",
    uso: "localizada em [LocatariaEmpresaEndereco],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaEmpresaDtAdmissao",
    descricao: "Data de admissão da locatária (PF)",
    exemplo: "01/02/2018",
    uso: "desde [LocatariaEmpresaDtAdmissao],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaEmpresaCargo",
    descricao: "Cargo da locatária (PF)",
    exemplo: "Coordenador de Obras",
    uso: "no cargo de [LocatariaEmpresaCargo],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaEmpresaSalario",
    descricao: "Salário da locatária (PF)",
    exemplo: "R$ 6.500,00",
    uso: "com salário de [LocatariaEmpresaSalario].",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaEmpresaOutroRendimento",
    descricao: "Outros rendimentos da locatária (PF)",
    exemplo: "Sim",
    uso: "Possui outros rendimentos: [LocatariaEmpresaOutroRendimento].",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaEmpresaOutroRendimentoValor",
    descricao: "Valor dos outros rendimentos da locatária (PF)",
    exemplo: "R$ 1.200,00",
    uso: "no valor de [LocatariaEmpresaOutroRendimentoValor],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaEmpresaOutroRendimentoProvem",
    descricao: "Origem dos outros rendimentos da locatária (PF)",
    exemplo: "Aluguel de imóvel próprio",
    uso: "provenientes de [LocatariaEmpresaOutroRendimentoProvem].",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaRepresentante",
    descricao: "Nome do representante legal que assina pela locatária (quando PJ)",
    exemplo: "Fernanda Lima Torres",
    uso: "neste ato representada por [LocatariaRepresentante],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaRepresentanteDTNascimento",
    descricao: "Data de nascimento do representante legal da locatária (quando PJ)",
    exemplo: "22/09/1985",
    uso: "nascido em [LocatariaRepresentanteDTNascimento],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaRepresentanteNacionalidade",
    descricao: "Nacionalidade do representante legal da locatária (quando PJ)",
    exemplo: "Brasileira",
    uso: "de nacionalidade [LocatariaRepresentanteNacionalidade],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaRepresentanteNaturalidade",
    descricao: "Naturalidade do representante legal da locatária (quando PJ)",
    exemplo: "São Paulo/SP",
    uso: "natural de [LocatariaRepresentanteNaturalidade],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaRepresentanteEstadoCivil",
    descricao: "Casado|Solteiro|Viúvo do representante legal da locatária (quando PJ)",
    exemplo: "Casado",
    uso: "estado civil [LocatariaRepresentanteEstadoCivil],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaRepresentanteRegimeCasamento",
    descricao: "Regime de casamento do representante legal da locatária (quando PJ)",
    exemplo: "Comunhão parcial de bens",
    uso: "sob o regime de [LocatariaRepresentanteRegimeCasamento],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaRepresentanteProfissao",
    descricao: "Profissão do representante legal da locatária (quando PJ)",
    exemplo: "Empresário",
    uso: "profissão [LocatariaRepresentanteProfissao],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaRepresentanteRG",
    descricao: "RG do representante legal da locatária (quando PJ)",
    exemplo: "12.345.678-9",
    uso: "portador da Cédula de Identidade RG nº [LocatariaRepresentanteRG]",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaRepresentanteRGOrgao",
    descricao: "Órgão emissor do RG do representante legal da locatária (quando PJ)",
    exemplo: "SSP/SP",
    uso: "–[LocatariaRepresentanteRGOrgao]",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaRepresentanteCPF",
    descricao: "CPF do representante legal da locatária (quando PJ)",
    exemplo: "123.456.789-00",
    uso: "inscrito no CPF sob o nº [LocatariaRepresentanteCPF],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaRepresentanteRGEmissao",
    descricao: "Data de emissão do RG do representante legal da locatária (quando PJ)",
    exemplo: "05/03/2005",
    uso: "em [LocatariaRepresentanteRGEmissao],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaRepresentanteEndereco",
    descricao: "Endereço residencial do representante legal da locatária (quando PJ)",
    exemplo: "Rua das Flores, 123 - Centro - São Paulo/SP - CEP 01310-100",
    uso: "residente em [LocatariaRepresentanteEndereco].",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaRepresentanteTelefone",
    descricao: "Telefone residencial ou celular do representante legal da locatária (quando PJ)",
    exemplo: "(11) 98765-4321",
    uso: "telefone [LocatariaRepresentanteTelefone],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaRepresentanteEmail",
    descricao: "E-mail do representante legal da locatária (quando PJ)",
    exemplo: "fernanda.torres@emailexemplo.com.br",
    uso: "e-mail [LocatariaRepresentanteEmail].",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaConjuge",
    descricao: "Nome do cônjuge da locatária (PF)",
    exemplo: "Ana Paula Ferreira",
    uso: "casado com [LocatariaConjuge],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaConjugeDtNascimento",
    descricao: "Data de nascimento do cônjuge da locatária",
    exemplo: "14/11/1987",
    uso: "nascida em [LocatariaConjugeDtNascimento],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaConjugeNacionalidade",
    descricao: "Nacionalidade do cônjuge da locatária",
    exemplo: "Brasileira",
    uso: "nacionalidade [LocatariaConjugeNacionalidade],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaConjugeNaturalidade",
    descricao: "Naturalidade do cônjuge da locatária",
    exemplo: "Campinas/SP",
    uso: "natural de [LocatariaConjugeNaturalidade],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaConjugeProfissao",
    descricao: "Profissão do cônjuge da locatária",
    exemplo: "Advogada",
    uso: "profissão [LocatariaConjugeProfissao],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaConjugeCPF",
    descricao: "CPF do cônjuge da locatária",
    exemplo: "987.654.321-00",
    uso: "CPF nº [LocatariaConjugeCPF]",
  },
  { categoria: "Locatária", tag: "LocatariaConjugeRG", descricao: "RG do cônjuge da locatária", exemplo: "23.456.789-0", uso: "RG nº [LocatariaConjugeRG]," },
  {
    categoria: "Locatária",
    tag: "LocatariaConjugeRGOrgao",
    descricao: "Órgão emissor do RG do cônjuge da locatária",
    exemplo: "SSP/SP",
    uso: "expedido por [LocatariaConjugeRGOrgao]",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaConjugeRGEmissao",
    descricao: "Data de emissão do RG do cônjuge da locatária",
    exemplo: "18/07/2007",
    uso: "em [LocatariaConjugeRGEmissao],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaConjugeTelefone",
    descricao: "Telefone do cônjuge da locatária",
    exemplo: "(11) 91234-5678",
    uso: "telefone [LocatariaConjugeTelefone],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaConjugeEmail",
    descricao: "E-mail do cônjuge da locatária",
    exemplo: "ana.ferreira@emailexemplo.com.br",
    uso: "e-mail [LocatariaConjugeEmail].",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaConjugeEmpresaTrabalha",
    descricao: "Empresa onde o cônjuge da locatária trabalha",
    exemplo: "Escritório de Advocacia Exemplo",
    uso: "empregada na empresa [LocatariaConjugeEmpresaTrabalha],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaConjugeEmpresaEndereco",
    descricao: "Endereço da empresa do cônjuge da locatária",
    exemplo: "Rua dos Advogados, 200 - São Paulo/SP - CEP 01452-000",
    uso: "localizada em [LocatariaConjugeEmpresaEndereco],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaConjugeEmpresaDtAdmissao",
    descricao: "Data de admissão do cônjuge da locatária",
    exemplo: "10/06/2015",
    uso: "desde [LocatariaConjugeEmpresaDtAdmissao],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaConjugeEmpresaCargo",
    descricao: "Cargo do cônjuge da locatária",
    exemplo: "Advogada Sênior",
    uso: "no cargo de [LocatariaConjugeEmpresaCargo],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaConjugeEmpresaSalario",
    descricao: "Salário do cônjuge da locatária",
    exemplo: "R$ 8.000,00",
    uso: "com salário de [LocatariaConjugeEmpresaSalario].",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaConjugeEmpresaOutroRendimento",
    descricao: "Outros rendimentos do cônjuge da locatária",
    exemplo: "Não",
    uso: "Possui outros rendimentos: [LocatariaConjugeEmpresaOutroRendimento].",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaConjugeEmpresaOutroRendimentoValor",
    descricao: "Valor dos outros rendimentos do cônjuge da locatária",
    exemplo: "R$ 0,00",
    uso: "no valor de [LocatariaConjugeEmpresaOutroRendimentoValor],",
  },
  {
    categoria: "Locatária",
    tag: "LocatariaConjugeEmpresaOutroRendimentoProvem",
    descricao: "Origem dos outros rendimentos do cônjuge da locatária",
    exemplo: "—",
    uso: "provenientes de [LocatariaConjugeEmpresaOutroRendimentoProvem].",
  },

  // ── Fiador ───────────────────────────────────────────────────────────────
  { categoria: "Fiador", tag: "FiadorTipoPessoa", descricao: "PJ|PF", exemplo: "PF", uso: "Pessoa: [FiadorTipoPessoa]." },
  {
    categoria: "Fiador",
    tag: "FiadorEmail",
    descricao: 'E-mails do fiador separados por "," ou ";" (PJ)',
    exemplo: "contato@empresaexemplo.com.br",
    uso: "contato via e-mail: [FiadorEmail].",
  },
  {
    categoria: "Fiador",
    tag: "FiadorRazaoSocial",
    descricao: "Razão social do fiador (PJ)",
    exemplo: "Comércio de Materiais Exemplo Ltda",
    uso: "tendo como fiadora a empresa [FiadorRazaoSocial],",
  },
  { categoria: "Fiador", tag: "FiadorCNPJ", descricao: "CNPJ do fiador (PJ)", exemplo: "12.345.678/0001-90", uso: "inscrita no CNPJ sob o nº [FiadorCNPJ]," },
  {
    categoria: "Fiador",
    tag: "FiadorEndereco",
    descricao: "Endereço do fiador PJ (ver padrão de separação das informações do endereço)",
    exemplo: "Av. Paulista, 1000 - Sala 12 - Bela Vista - São Paulo/SP - CEP 01310-100",
    uso: "com sede em [FiadorEndereco],",
  },
  { categoria: "Fiador", tag: "FiadorTelefone", descricao: "Telefone do fiador PJ", exemplo: "(11) 3456-7890", uso: "telefone [FiadorTelefone]," },
  {
    categoria: "Fiador",
    tag: "FiadorDataConstituicao",
    descricao: "Data de constituição do fiador (PJ)",
    exemplo: "12/04/2010",
    uso: "constituída em [FiadorDataConstituicao],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorCapitalSocial",
    descricao: "Capital social do fiador (PJ)",
    exemplo: "R$ 100.000,00",
    uso: "com capital social de [FiadorCapitalSocial].",
  },
  {
    categoria: "Fiador",
    tag: "FiadorEnderecoFilial",
    descricao: "Endereço da filial do fiador (PJ)",
    exemplo: "Rua Comercial, 45 - Vila Industrial - Campinas/SP - CEP 13030-000",
    uso: "com filial em [FiadorEnderecoFilial],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorTelefoneFilial",
    descricao: "Telefone da filial do fiador (PJ)",
    exemplo: "(19) 3234-5678",
    uso: "telefone da filial [FiadorTelefoneFilial],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorRamoAtividade",
    descricao: "Ramo de atividade do fiador (PJ)",
    exemplo: "Comércio varejista de materiais de construção",
    uso: "atuante no ramo de [FiadorRamoAtividade],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorProdutosServicos",
    descricao: "Produtos e serviços do fiador (PJ)",
    exemplo: "Venda de materiais de construção e ferragens",
    uso: "com produtos e serviços: [FiadorProdutosServicos].",
  },
  {
    categoria: "Fiador",
    tag: "FiadorQtdeFuncionarios",
    descricao: "Número de funcionários do fiador (PJ)",
    exemplo: "18",
    uso: "possui [FiadorQtdeFuncionarios] funcionários",
  },
  {
    categoria: "Fiador",
    tag: "FiadorFaturamentoMensal",
    descricao: "Faturamento mensal do fiador (PJ)",
    exemplo: "R$ 80.000,00",
    uso: "com faturamento mensal de [FiadorFaturamentoMensal].",
  },
  { categoria: "Fiador", tag: "FiadorNome", descricao: "Nome do fiador (PF)", exemplo: "Carlos Eduardo Pereira", uso: "tendo como fiador [FiadorNome]," },
  {
    categoria: "Fiador",
    tag: "FiadorDTNascimento",
    descricao: "Data de nascimento do fiador (PF)",
    exemplo: "10/03/1978",
    uso: "nascido em [FiadorDTNascimento],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorNacionalidade",
    descricao: "Nacionalidade do fiador (PF)",
    exemplo: "Brasileira",
    uso: "de nacionalidade [FiadorNacionalidade],",
  },
  { categoria: "Fiador", tag: "FiadorNaturalidade", descricao: "Naturalidade do fiador (PF)", exemplo: "Campinas/SP", uso: "natural de [FiadorNaturalidade]," },
  { categoria: "Fiador", tag: "FiadorEstadoCivil", descricao: "Casado|Solteiro|Viúvo (PF)", exemplo: "Casado", uso: "estado civil [FiadorEstadoCivil]," },
  {
    categoria: "Fiador",
    tag: "FiadorRegimeCasamento",
    descricao: "Regime de casamento do fiador (PF)",
    exemplo: "Comunhão parcial de bens",
    uso: "sob o regime de [FiadorRegimeCasamento],",
  },
  { categoria: "Fiador", tag: "FiadorProfissao", descricao: "Profissão do fiador (PF)", exemplo: "Engenheiro Civil", uso: "profissão [FiadorProfissao]," },
  { categoria: "Fiador", tag: "FiadorCPF", descricao: "CPF do fiador (PF)", exemplo: "123.456.789-00", uso: "portador do CPF nº [FiadorCPF]" },
  { categoria: "Fiador", tag: "FiadorRG", descricao: "RG do fiador (PF)", exemplo: "12.345.678-9", uso: "e RG nº [FiadorRG]," },
  { categoria: "Fiador", tag: "FiadorRGOrgao", descricao: "Órgão emissor do RG do fiador (PF)", exemplo: "SSP/SP", uso: "expedido por [FiadorRGOrgao]" },
  { categoria: "Fiador", tag: "FiadorRGEmissao", descricao: "Data de emissão do RG do fiador (PF)", exemplo: "05/03/2005", uso: "em [FiadorRGEmissao]," },
  {
    categoria: "Fiador",
    tag: "FiadorPFEndereco",
    descricao: "Endereço residencial do fiador (PF)",
    exemplo: "Rua das Flores, 123 - Centro - São Paulo/SP - CEP 01310-100",
    uso: "residente em [FiadorPFEndereco],",
  },
  { categoria: "Fiador", tag: "FiadorPFTelefone", descricao: "Telefone do fiador (PF)", exemplo: "(11) 98765-4321", uso: "telefone [FiadorPFTelefone]," },
  {
    categoria: "Fiador",
    tag: "FiadorPFEmail",
    descricao: 'E-mails do fiador (PF) separados por "," ou ";"',
    exemplo: "carlos.pereira@emailexemplo.com.br",
    uso: "e-mail [FiadorPFEmail].",
  },
  {
    categoria: "Fiador",
    tag: "FiadorEmpresaTrabalha",
    descricao: "Empresa onde o fiador (PF) trabalha",
    exemplo: "Construtora Exemplo Ltda",
    uso: "empregado na empresa [FiadorEmpresaTrabalha],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorEmpresaEndereco",
    descricao: "Endereço da empresa onde o fiador (PF) trabalha",
    exemplo: "Av. Paulista, 1000 - São Paulo/SP - CEP 01310-100",
    uso: "localizada em [FiadorEmpresaEndereco],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorEmpresaDtAdmissao",
    descricao: "Data de admissão do fiador (PF)",
    exemplo: "01/02/2018",
    uso: "desde [FiadorEmpresaDtAdmissao],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorEmpresaCargo",
    descricao: "Cargo do fiador (PF)",
    exemplo: "Coordenador de Obras",
    uso: "no cargo de [FiadorEmpresaCargo],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorEmpresaSalario",
    descricao: "Salário do fiador (PF)",
    exemplo: "R$ 6.500,00",
    uso: "com salário de [FiadorEmpresaSalario].",
  },
  {
    categoria: "Fiador",
    tag: "FiadorEmpresaOutroRendimento",
    descricao: "Outros rendimentos do fiador (PF)",
    exemplo: "Sim",
    uso: "Possui outros rendimentos: [FiadorEmpresaOutroRendimento].",
  },
  {
    categoria: "Fiador",
    tag: "FiadorEmpresaOutroRendimentoValor",
    descricao: "Valor dos outros rendimentos do fiador (PF)",
    exemplo: "R$ 1.200,00",
    uso: "no valor de [FiadorEmpresaOutroRendimentoValor],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorEmpresaOutroRendimentoProvem",
    descricao: "Origem dos outros rendimentos do fiador (PF)",
    exemplo: "Aluguel de imóvel próprio",
    uso: "provenientes de [FiadorEmpresaOutroRendimentoProvem].",
  },
  { categoria: "Fiador", tag: "FiadorConjuge", descricao: "Nome do cônjuge do fiador", exemplo: "Ana Paula Ferreira", uso: "casado com [FiadorConjuge]," },
  {
    categoria: "Fiador",
    tag: "FiadorConjugeDtNascimento",
    descricao: "Data de nascimento do cônjuge do fiador",
    exemplo: "14/11/1987",
    uso: "nascida em [FiadorConjugeDtNascimento],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorConjugeNacionalidade",
    descricao: "Nacionalidade do cônjuge do fiador",
    exemplo: "Brasileira",
    uso: "nacionalidade [FiadorConjugeNacionalidade],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorConjugeNaturalidade",
    descricao: "Naturalidade do cônjuge do fiador",
    exemplo: "Campinas/SP",
    uso: "natural de [FiadorConjugeNaturalidade],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorConjugeProfissao",
    descricao: "Profissão do cônjuge do fiador",
    exemplo: "Advogada",
    uso: "profissão [FiadorConjugeProfissao],",
  },
  { categoria: "Fiador", tag: "FiadorConjugeCPF", descricao: "CPF do cônjuge do fiador", exemplo: "987.654.321-00", uso: "CPF nº [FiadorConjugeCPF]" },
  { categoria: "Fiador", tag: "FiadorConjugeRG", descricao: "RG do cônjuge do fiador", exemplo: "23.456.789-0", uso: "RG nº [FiadorConjugeRG]," },
  {
    categoria: "Fiador",
    tag: "FiadorConjugeRGOrgao",
    descricao: "Órgão emissor do RG do cônjuge do fiador",
    exemplo: "SSP/SP",
    uso: "expedido por [FiadorConjugeRGOrgao]",
  },
  {
    categoria: "Fiador",
    tag: "FiadorConjugeRGEmissao",
    descricao: "Data de emissão do RG do cônjuge do fiador",
    exemplo: "18/07/2007",
    uso: "em [FiadorConjugeRGEmissao],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorConjugeTelefone",
    descricao: "Telefone do cônjuge do fiador",
    exemplo: "(11) 91234-5678",
    uso: "telefone [FiadorConjugeTelefone],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorConjugeEmail",
    descricao: "E-mail do cônjuge do fiador",
    exemplo: "ana.ferreira@emailexemplo.com.br",
    uso: "e-mail [FiadorConjugeEmail].",
  },
  {
    categoria: "Fiador",
    tag: "FiadorConjugeEmpresaTrabalha",
    descricao: "Empresa onde o cônjuge do fiador trabalha",
    exemplo: "Escritório de Advocacia Exemplo",
    uso: "empregada na empresa [FiadorConjugeEmpresaTrabalha],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorConjugeEmpresaEndereco",
    descricao: "Endereço da empresa do cônjuge do fiador",
    exemplo: "Rua dos Advogados, 200 - São Paulo/SP - CEP 01452-000",
    uso: "localizada em [FiadorConjugeEmpresaEndereco],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorConjugeEmpresaDtAdmissao",
    descricao: "Data de admissão do cônjuge do fiador",
    exemplo: "10/06/2015",
    uso: "desde [FiadorConjugeEmpresaDtAdmissao],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorConjugeEmpresaCargo",
    descricao: "Cargo do cônjuge do fiador",
    exemplo: "Advogada Sênior",
    uso: "no cargo de [FiadorConjugeEmpresaCargo],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorConjugeEmpresaSalario",
    descricao: "Salário do cônjuge do fiador",
    exemplo: "R$ 8.000,00",
    uso: "com salário de [FiadorConjugeEmpresaSalario].",
  },
  {
    categoria: "Fiador",
    tag: "FiadorConjugeEmpresaOutroRendimento",
    descricao: "Outros rendimentos do cônjuge do fiador",
    exemplo: "Não",
    uso: "Possui outros rendimentos: [FiadorConjugeEmpresaOutroRendimento].",
  },
  {
    categoria: "Fiador",
    tag: "FiadorConjugeEmpresaOutroRendimentoValor",
    descricao: "Valor dos outros rendimentos do cônjuge do fiador",
    exemplo: "R$ 0,00",
    uso: "no valor de [FiadorConjugeEmpresaOutroRendimentoValor],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorConjugeEmpresaOutroRendimentoProvem",
    descricao: "Origem dos outros rendimentos do cônjuge do fiador",
    exemplo: "—",
    uso: "provenientes de [FiadorConjugeEmpresaOutroRendimentoProvem].",
  },
  {
    categoria: "Fiador",
    tag: "FiadorRepresentante",
    descricao:
      "Nome do representante legal que assina pelo fiador (quando PJ) — só preenche quando PJ; equivale a FiadorNome/FiadorCPF/FiadorPFEndereco, que já carregam o mesmo dado",
    exemplo: "Roberto Almeida Costa",
    uso: "neste ato representado por [FiadorRepresentante],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorRepresentanteDTNascimento",
    descricao: "Data de nascimento do representante legal do fiador (quando PJ) — equivale a FiadorDTNascimento",
    exemplo: "22/09/1985",
    uso: "nascido em [FiadorRepresentanteDTNascimento],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorRepresentanteNacionalidade",
    descricao: "Nacionalidade do representante legal do fiador (quando PJ) — equivale a FiadorNacionalidade",
    exemplo: "Brasileira",
    uso: "de nacionalidade [FiadorRepresentanteNacionalidade],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorRepresentanteNaturalidade",
    descricao: "Naturalidade do representante legal do fiador (quando PJ) — equivale a FiadorNaturalidade",
    exemplo: "São Paulo/SP",
    uso: "natural de [FiadorRepresentanteNaturalidade],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorRepresentanteEstadoCivil",
    descricao: "Casado|Solteiro|Viúvo do representante legal do fiador (quando PJ) — equivale a FiadorEstadoCivil",
    exemplo: "Casado",
    uso: "estado civil [FiadorRepresentanteEstadoCivil],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorRepresentanteRegimeCasamento",
    descricao: "Regime de casamento do representante legal do fiador (quando PJ) — equivale a FiadorRegimeCasamento",
    exemplo: "Comunhão parcial de bens",
    uso: "sob o regime de [FiadorRepresentanteRegimeCasamento],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorRepresentanteProfissao",
    descricao: "Profissão do representante legal do fiador (quando PJ) — equivale a FiadorProfissao",
    exemplo: "Empresário",
    uso: "profissão [FiadorRepresentanteProfissao],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorRepresentanteCPF",
    descricao: "CPF do representante legal do fiador (quando PJ)",
    exemplo: "123.456.789-00",
    uso: "inscrito no CPF sob o nº [FiadorRepresentanteCPF],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorRepresentanteRG",
    descricao: "RG do representante legal do fiador (quando PJ)",
    exemplo: "12.345.678-9",
    uso: "portador da Cédula de Identidade RG nº [FiadorRepresentanteRG]",
  },
  {
    categoria: "Fiador",
    tag: "FiadorRepresentanteRGOrgao",
    descricao: "Órgão emissor do RG do representante legal do fiador (quando PJ)",
    exemplo: "SSP/SP",
    uso: "–[FiadorRepresentanteRGOrgao]",
  },
  {
    categoria: "Fiador",
    tag: "FiadorRepresentanteRGEmissao",
    descricao: "Data de emissão do RG do representante legal do fiador (quando PJ)",
    exemplo: "05/03/2005",
    uso: "em [FiadorRepresentanteRGEmissao],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorRepresentanteEndereco",
    descricao: "Endereço residencial do representante legal do fiador (quando PJ)",
    exemplo: "Rua das Flores, 123 - Centro - São Paulo/SP - CEP 01310-100",
    uso: "residente em [FiadorRepresentanteEndereco].",
  },
  {
    categoria: "Fiador",
    tag: "FiadorRepresentanteTelefone",
    descricao: "Telefone residencial ou celular do representante legal do fiador (quando PJ)",
    exemplo: "(11) 98765-4321",
    uso: "telefone [FiadorRepresentanteTelefone],",
  },
  {
    categoria: "Fiador",
    tag: "FiadorRepresentanteEmail",
    descricao: "E-mail do representante legal do fiador (quando PJ)",
    exemplo: "roberto.costa@emailexemplo.com.br",
    uso: "e-mail [FiadorRepresentanteEmail].",
  },

  // ── Seguradora ───────────────────────────────────────────────────────────

  { categoria: "Seguradora", tag: "SeguradoraTipoPessoa", descricao: "PJ|PF", exemplo: "PJ", uso: "Pessoa: [SeguradoraTipoPessoa]." },
  {
    categoria: "Seguradora",
    tag: "SeguradoraEmail",
    descricao: 'E-mails da seguradora separados por "," ou ";" (PJ)',
    exemplo: "contato@seguradoraexemplo.com.br",
    uso: "contato via e-mail: [SeguradoraEmail].",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraRazaoSocial",
    descricao: "Razão social da seguradora (PJ)",
    exemplo: "Seguradora Exemplo Fiança Ltda",
    uso: "contratado junto à [SeguradoraRazaoSocial],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraCNPJ",
    descricao: "CNPJ da seguradora (PJ)",
    exemplo: "12.345.678/0001-90",
    uso: "inscrita no CNPJ sob o nº [SeguradoraCNPJ],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraEndereco",
    descricao: "Endereço da seguradora PJ (ver padrão de separação das informações do endereço)",
    exemplo: "Av. Paulista, 1000 - Sala 12 - Bela Vista - São Paulo/SP - CEP 01310-100",
    uso: "com sede em [SeguradoraEndereco],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraTelefone",
    descricao: "Telefone da seguradora PJ",
    exemplo: "(11) 3456-7890",
    uso: "telefone [SeguradoraTelefone],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraDataConstituicao",
    descricao: "Data de constituição da seguradora (PJ)",
    exemplo: "12/04/2010",
    uso: "constituída em [SeguradoraDataConstituicao],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraCapitalSocial",
    descricao: "Capital social da seguradora (PJ)",
    exemplo: "R$ 100.000,00",
    uso: "com capital social de [SeguradoraCapitalSocial].",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraEnderecoFilial",
    descricao: "Endereço da filial da seguradora (PJ)",
    exemplo: "Rua Comercial, 45 - Vila Industrial - Campinas/SP - CEP 13030-000",
    uso: "com filial em [SeguradoraEnderecoFilial],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraTelefoneFilial",
    descricao: "Telefone da filial da seguradora (PJ)",
    exemplo: "(19) 3234-5678",
    uso: "telefone da filial [SeguradoraTelefoneFilial],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraRamoAtividade",
    descricao: "Ramo de atividade da seguradora (PJ)",
    exemplo: "Seguros e fiança locatícia",
    uso: "atuante no ramo de [SeguradoraRamoAtividade],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraProdutosServicos",
    descricao: "Produtos e serviços da seguradora (PJ)",
    exemplo: "Seguro fiança para locação residencial e comercial",
    uso: "com produtos e serviços: [SeguradoraProdutosServicos].",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraQtdeFuncionarios",
    descricao: "Número de funcionários da seguradora (PJ)",
    exemplo: "18",
    uso: "possui [SeguradoraQtdeFuncionarios] funcionários",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraFaturamentoMensal",
    descricao: "Faturamento mensal da seguradora (PJ)",
    exemplo: "R$ 80.000,00",
    uso: "com faturamento mensal de [SeguradoraFaturamentoMensal].",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraNome",
    descricao: "Nome da seguradora (PF, caso excepcional)",
    exemplo: "João da Silva Santos",
    uso: "neste ato representado por [SeguradoraNome],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraDTNascimento",
    descricao: "Data de nascimento da seguradora (PF)",
    exemplo: "22/09/1985",
    uso: "nascido em [SeguradoraDTNascimento],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraNacionalidade",
    descricao: "Nacionalidade da seguradora (PF)",
    exemplo: "Brasileira",
    uso: "de nacionalidade [SeguradoraNacionalidade],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraNaturalidade",
    descricao: "Naturalidade da seguradora (PF)",
    exemplo: "São Paulo/SP",
    uso: "natural de [SeguradoraNaturalidade],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraEstadoCivil",
    descricao: "Casado|Solteiro|Viúvo (PF)",
    exemplo: "Casado",
    uso: "estado civil [SeguradoraEstadoCivil],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraRegimeCasamento",
    descricao: "Regime de casamento da seguradora (PF)",
    exemplo: "Comunhão parcial de bens",
    uso: "sob o regime de [SeguradoraRegimeCasamento],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraProfissao",
    descricao: "Profissão da seguradora (PF)",
    exemplo: "Corretor de Seguros",
    uso: "profissão [SeguradoraProfissao],",
  },
  { categoria: "Seguradora", tag: "SeguradoraCPF", descricao: "CPF da seguradora (PF)", exemplo: "123.456.789-00", uso: "portador do CPF nº [SeguradoraCPF]" },
  { categoria: "Seguradora", tag: "SeguradoraRG", descricao: "RG da seguradora (PF)", exemplo: "12.345.678-9", uso: "e RG nº [SeguradoraRG]," },
  {
    categoria: "Seguradora",
    tag: "SeguradoraRGOrgao",
    descricao: "Órgão emissor do RG da seguradora (PF)",
    exemplo: "SSP/SP",
    uso: "expedido por [SeguradoraRGOrgao]",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraRGEmissao",
    descricao: "Data de emissão do RG da seguradora (PF)",
    exemplo: "05/03/2005",
    uso: "em [SeguradoraRGEmissao],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraPFEndereco",
    descricao: "Endereço residencial da seguradora (PF)",
    exemplo: "Rua das Flores, 123 - Centro - São Paulo/SP - CEP 01310-100",
    uso: "residente em [SeguradoraPFEndereco],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraPFTelefone",
    descricao: "Telefone da seguradora (PF)",
    exemplo: "(11) 98765-4321",
    uso: "telefone [SeguradoraPFTelefone],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraPFEmail",
    descricao: 'E-mails da seguradora (PF) separados por "," ou ";"',
    exemplo: "joao.silva@emailexemplo.com.br",
    uso: "e-mail [SeguradoraPFEmail].",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraEmpresaTrabalha",
    descricao: "Empresa onde a seguradora (PF) trabalha",
    exemplo: "Construtora Exemplo Ltda",
    uso: "empregado na empresa [SeguradoraEmpresaTrabalha],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraEmpresaEndereco",
    descricao: "Endereço da empresa onde a seguradora (PF) trabalha",
    exemplo: "Av. Paulista, 1000 - São Paulo/SP - CEP 01310-100",
    uso: "localizada em [SeguradoraEmpresaEndereco],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraEmpresaDtAdmissao",
    descricao: "Data de admissão da seguradora (PF)",
    exemplo: "01/02/2018",
    uso: "desde [SeguradoraEmpresaDtAdmissao],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraEmpresaCargo",
    descricao: "Cargo da seguradora (PF)",
    exemplo: "Coordenador de Obras",
    uso: "no cargo de [SeguradoraEmpresaCargo],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraEmpresaSalario",
    descricao: "Salário da seguradora (PF)",
    exemplo: "R$ 6.500,00",
    uso: "com salário de [SeguradoraEmpresaSalario].",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraEmpresaOutroRendimento",
    descricao: "Outros rendimentos da seguradora (PF)",
    exemplo: "Sim",
    uso: "Possui outros rendimentos: [SeguradoraEmpresaOutroRendimento].",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraEmpresaOutroRendimentoValor",
    descricao: "Valor dos outros rendimentos da seguradora (PF)",
    exemplo: "R$ 1.200,00",
    uso: "no valor de [SeguradoraEmpresaOutroRendimentoValor],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraEmpresaOutroRendimentoProvem",
    descricao: "Origem dos outros rendimentos da seguradora (PF)",
    exemplo: "Aluguel de imóvel próprio",
    uso: "provenientes de [SeguradoraEmpresaOutroRendimentoProvem].",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraConjuge",
    descricao: "Nome do cônjuge da seguradora (PF)",
    exemplo: "Ana Paula Ferreira",
    uso: "casado com [SeguradoraConjuge],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraConjugeDtNascimento",
    descricao: "Data de nascimento do cônjuge da seguradora",
    exemplo: "14/11/1987",
    uso: "nascida em [SeguradoraConjugeDtNascimento],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraConjugeNacionalidade",
    descricao: "Nacionalidade do cônjuge da seguradora",
    exemplo: "Brasileira",
    uso: "nacionalidade [SeguradoraConjugeNacionalidade],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraConjugeNaturalidade",
    descricao: "Naturalidade do cônjuge da seguradora",
    exemplo: "Campinas/SP",
    uso: "natural de [SeguradoraConjugeNaturalidade],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraConjugeProfissao",
    descricao: "Profissão do cônjuge da seguradora",
    exemplo: "Advogada",
    uso: "profissão [SeguradoraConjugeProfissao],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraConjugeCPF",
    descricao: "CPF do cônjuge da seguradora",
    exemplo: "987.654.321-00",
    uso: "CPF nº [SeguradoraConjugeCPF]",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraConjugeRG",
    descricao: "RG do cônjuge da seguradora",
    exemplo: "23.456.789-0",
    uso: "RG nº [SeguradoraConjugeRG],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraConjugeRGOrgao",
    descricao: "Órgão emissor do RG do cônjuge da seguradora",
    exemplo: "SSP/SP",
    uso: "expedido por [SeguradoraConjugeRGOrgao]",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraConjugeRGEmissao",
    descricao: "Data de emissão do RG do cônjuge da seguradora",
    exemplo: "18/07/2007",
    uso: "em [SeguradoraConjugeRGEmissao],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraConjugeTelefone",
    descricao: "Telefone do cônjuge da seguradora",
    exemplo: "(11) 91234-5678",
    uso: "telefone [SeguradoraConjugeTelefone],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraConjugeEmail",
    descricao: "E-mail do cônjuge da seguradora",
    exemplo: "ana.ferreira@emailexemplo.com.br",
    uso: "e-mail [SeguradoraConjugeEmail].",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraConjugeEmpresaTrabalha",
    descricao: "Empresa onde o cônjuge da seguradora trabalha",
    exemplo: "Escritório de Advocacia Exemplo",
    uso: "empregada na empresa [SeguradoraConjugeEmpresaTrabalha],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraConjugeEmpresaEndereco",
    descricao: "Endereço da empresa do cônjuge da seguradora",
    exemplo: "Rua dos Advogados, 200 - São Paulo/SP - CEP 01452-000",
    uso: "localizada em [SeguradoraConjugeEmpresaEndereco],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraConjugeEmpresaDtAdmissao",
    descricao: "Data de admissão do cônjuge da seguradora",
    exemplo: "10/06/2015",
    uso: "desde [SeguradoraConjugeEmpresaDtAdmissao],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraConjugeEmpresaCargo",
    descricao: "Cargo do cônjuge da seguradora",
    exemplo: "Advogada Sênior",
    uso: "no cargo de [SeguradoraConjugeEmpresaCargo],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraConjugeEmpresaSalario",
    descricao: "Salário do cônjuge da seguradora",
    exemplo: "R$ 8.000,00",
    uso: "com salário de [SeguradoraConjugeEmpresaSalario].",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraConjugeEmpresaOutroRendimento",
    descricao: "Outros rendimentos do cônjuge da seguradora",
    exemplo: "Não",
    uso: "Possui outros rendimentos: [SeguradoraConjugeEmpresaOutroRendimento].",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraConjugeEmpresaOutroRendimentoValor",
    descricao: "Valor dos outros rendimentos do cônjuge da seguradora",
    exemplo: "R$ 0,00",
    uso: "no valor de [SeguradoraConjugeEmpresaOutroRendimentoValor],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraConjugeEmpresaOutroRendimentoProvem",
    descricao: "Origem dos outros rendimentos do cônjuge da seguradora",
    exemplo: "—",
    uso: "provenientes de [SeguradoraConjugeEmpresaOutroRendimentoProvem].",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraRepresentante",
    descricao:
      "Nome do representante legal que assina pela seguradora (quando PJ) — só preenche quando PJ; equivale a SeguradoraNome/SeguradoraCPF/SeguradoraPFEndereco, que já carregam o mesmo dado",
    exemplo: "Roberto Almeida Costa",
    uso: "neste ato representada por [SeguradoraRepresentante],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraRepresentanteDTNascimento",
    descricao: "Data de nascimento do representante legal da seguradora (quando PJ) — equivale a SeguradoraDTNascimento",
    exemplo: "22/09/1985",
    uso: "nascido em [SeguradoraRepresentanteDTNascimento],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraRepresentanteNacionalidade",
    descricao: "Nacionalidade do representante legal da seguradora (quando PJ) — equivale a SeguradoraNacionalidade",
    exemplo: "Brasileira",
    uso: "de nacionalidade [SeguradoraRepresentanteNacionalidade],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraRepresentanteNaturalidade",
    descricao: "Naturalidade do representante legal da seguradora (quando PJ) — equivale a SeguradoraNaturalidade",
    exemplo: "São Paulo/SP",
    uso: "natural de [SeguradoraRepresentanteNaturalidade],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraRepresentanteEstadoCivil",
    descricao: "Casado|Solteiro|Viúvo do representante legal da seguradora (quando PJ) — equivale a SeguradoraEstadoCivil",
    exemplo: "Casado",
    uso: "estado civil [SeguradoraRepresentanteEstadoCivil],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraRepresentanteRegimeCasamento",
    descricao: "Regime de casamento do representante legal da seguradora (quando PJ) — equivale a SeguradoraRegimeCasamento",
    exemplo: "Comunhão parcial de bens",
    uso: "sob o regime de [SeguradoraRepresentanteRegimeCasamento],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraRepresentanteProfissao",
    descricao: "Profissão do representante legal da seguradora (quando PJ) — equivale a SeguradoraProfissao",
    exemplo: "Empresário",
    uso: "profissão [SeguradoraRepresentanteProfissao],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraRepresentanteCPF",
    descricao: "CPF do representante legal da seguradora (quando PJ)",
    exemplo: "123.456.789-00",
    uso: "inscrito no CPF sob o nº [SeguradoraRepresentanteCPF],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraRepresentanteRG",
    descricao: "RG do representante legal da seguradora (quando PJ)",
    exemplo: "12.345.678-9",
    uso: "portador da Cédula de Identidade RG nº [SeguradoraRepresentanteRG]",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraRepresentanteRGOrgao",
    descricao: "Órgão emissor do RG do representante legal da seguradora (quando PJ)",
    exemplo: "SSP/SP",
    uso: "–[SeguradoraRepresentanteRGOrgao]",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraRepresentanteRGEmissao",
    descricao: "Data de emissão do RG do representante legal da seguradora (quando PJ)",
    exemplo: "05/03/2005",
    uso: "em [SeguradoraRepresentanteRGEmissao],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraRepresentanteEndereco",
    descricao: "Endereço residencial do representante legal da seguradora (quando PJ)",
    exemplo: "Rua das Flores, 123 - Centro - São Paulo/SP - CEP 01310-100",
    uso: "residente em [SeguradoraRepresentanteEndereco].",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraRepresentanteTelefone",
    descricao: "Telefone residencial ou celular do representante legal da seguradora (quando PJ)",
    exemplo: "(11) 98765-4321",
    uso: "telefone [SeguradoraRepresentanteTelefone],",
  },
  {
    categoria: "Seguradora",
    tag: "SeguradoraRepresentanteEmail",
    descricao: "E-mail do representante legal da seguradora (quando PJ)",
    exemplo: "roberto.costa@emailexemplo.com.br",
    uso: "e-mail [SeguradoraRepresentanteEmail].",
  },

  // ── Caucionante ───────────────────────────────────────────────────────────
  {
    categoria: "Caucionante",
    tag: "CaucionanteRazaoSocial",
    descricao: "Razão social da empresa caucionante",
    exemplo: "Lima & Lima Comércio de Móveis Ltda EPP",
    uso: "a empresa [CaucionanteRazaoSocial],",
  },
  {
    categoria: "Caucionante",
    tag: "CaucionanteCNPJ",
    descricao: "CNPJ da empresa caucionante",
    exemplo: "04.462.250/0001-02",
    uso: "portadora do CNPJ nº [CaucionanteCNPJ],",
  },
  {
    categoria: "Caucionante",
    tag: "CaucionanteEndereco",
    descricao: "Endereço da empresa caucionante",
    exemplo: "Rua Antonio Ferragut, nº 826 - Jardim Primavera - Vinhedo/SP - CEP 13280-001",
    uso: "com sede em [CaucionanteEndereco],",
  },
  {
    categoria: "Caucionante",
    tag: "CaucionanteRepresentante",
    descricao: "Nome do representante legal da caucionante",
    exemplo: "Paulo Eduardo de Lima",
    uso: "representada por [CaucionanteRepresentante],",
  },
  {
    categoria: "Caucionante",
    tag: "CaucionanteRepresentanteNacionalidade",
    descricao: "Nacionalidade do representante legal da caucionante",
    exemplo: "Brasileiro",
    uso: "[CaucionanteRepresentanteNacionalidade],",
  },
  {
    categoria: "Caucionante",
    tag: "CaucionanteRepresentanteEstadoCivil",
    descricao: "Estado civil do representante legal da caucionante",
    exemplo: "Solteiro",
    uso: "[CaucionanteRepresentanteEstadoCivil],",
  },
  {
    categoria: "Caucionante",
    tag: "CaucionanteRepresentanteProfissao",
    descricao: "Profissão do representante legal da caucionante",
    exemplo: "Empresário",
    uso: "[CaucionanteRepresentanteProfissao],",
  },
  {
    categoria: "Caucionante",
    tag: "CaucionanteRepresentanteRG",
    descricao: "RG do representante legal da caucionante",
    exemplo: "27.606.518-9",
    uso: "portador do RG nº [CaucionanteRepresentanteRG]",
  },
  {
    categoria: "Caucionante",
    tag: "CaucionanteRepresentanteRGOrgao",
    descricao: "Órgão emissor do RG do representante legal da caucionante",
    exemplo: "SSP/SP",
    uso: "[CaucionanteRepresentanteRGOrgao]",
  },
  {
    categoria: "Caucionante",
    tag: "CaucionanteRepresentanteCPF",
    descricao: "CPF do representante legal da caucionante",
    exemplo: "262.112.788-61",
    uso: "CPF nº [CaucionanteRepresentanteCPF],",
  },
  {
    categoria: "Caucionante",
    tag: "CaucionanteRepresentanteEndereco",
    descricao: "Endereço residencial do representante legal da caucionante",
    exemplo: "Rua Antonio Peixoto, nº 191 - Valinhos/SP - CEP 13273-641",
    uso: "residente e domiciliado em [CaucionanteRepresentanteEndereco].",
  },

  // ── Complemento da Garantia do Imóvel ─────────────────────────────────────
  {
    categoria: "Garantia do Imóvel",
    tag: "GarantiaDescricaoImovel",
    descricao: "Descrição completa do imóvel oferecido em garantia",
    exemplo: "Lote de terreno nº 79...",
    uso: "[GarantiaDescricaoImovel]",
  },
  {
    categoria: "Garantia do Imóvel",
    tag: "GarantiaCadastroMunicipal",
    descricao: "Cadastro municipal do imóvel oferecido em garantia",
    exemplo: "12844/00",
    uso: "cadastro municipal nº [GarantiaCadastroMunicipal],",
  },
  {
    categoria: "Garantia do Imóvel",
    tag: "GarantiaSetor",
    descricao: "Setor cadastral do imóvel oferecido em garantia",
    exemplo: "5593",
    uso: "setor [GarantiaSetor],",
  },
  {
    categoria: "Garantia do Imóvel",
    tag: "GarantiaQuarteirao",
    descricao: "Quarteirão cadastral do imóvel oferecido em garantia",
    exemplo: "997",
    uso: "quarteirão [GarantiaQuarteirao].",
  },

  // ── Garantia do Imóvel ───────────────────────────────────────────────────
  {
    categoria: "Garantia do Imóvel",
    tag: "GarantiaTipoImovel",
    descricao: "Tipo do imóvel de garantia",
    exemplo: "Apartamento",
    uso: "O imóvel dado em garantia é do tipo [GarantiaTipoImovel],",
  },
  { categoria: "Garantia do Imóvel", tag: "GarantiaRGI", descricao: "RGI da garantia", exemplo: "12345", uso: "RGI nº [GarantiaRGI]," },
  {
    categoria: "Garantia do Imóvel",
    tag: "GarantiaMatricula",
    descricao: "Matrícula da garantia",
    exemplo: "56.789",
    uso: "matrícula nº [GarantiaMatricula],",
  },
  {
    categoria: "Garantia do Imóvel",
    tag: "GarantiaCartorio",
    descricao: "Cartório da garantia",
    exemplo: "1º Cartório de Registro de Imóveis de São Paulo",
    uso: "registrado no [GarantiaCartorio],",
  },
  { categoria: "Garantia do Imóvel", tag: "GarantiaLivro", descricao: "Livro de registro da garantia", exemplo: "2", uso: "livro [GarantiaLivro]," },
  { categoria: "Garantia do Imóvel", tag: "GarantiaFolha", descricao: "Folha do livro de registro da garantia", exemplo: "145", uso: "folha [GarantiaFolha]," },
  {
    categoria: "Garantia do Imóvel",
    tag: "GarantiaEndereco",
    descricao: "Endereço do imóvel da garantia",
    exemplo: "Rua Nova Esperança, 456 - Jardim Primavera - São Paulo/SP - CEP 04567-000",
    uso: "localizado em [GarantiaEndereco].",
  },
];

export const TAGS_CONDICIONAIS_TEMPLATE_CONTRATO = [
  { categoria: "Garantia", condicao: "GarantiaCaucao", descricao: "Bloco exibido somente quando a garantia da proposta inclui Caução", exemplo: "ativa" },
  {
    categoria: "Garantia",
    condicao: "GarantiaSeguroFianca",
    descricao: "Bloco exibido somente quando a garantia da proposta inclui Seguro Fiança",
    exemplo: "ativa",
  },
  { categoria: "Garantia", condicao: "GarantiaFiador", descricao: "Bloco exibido somente quando a garantia da proposta inclui Fiador", exemplo: "ativa" },
  { categoria: "Garantia", condicao: "SemGarantia", descricao: "Bloco exibido somente quando a proposta não tem nenhuma garantia", exemplo: "inativa" },
  {
    categoria: "Garantia",
    condicao: "GarantiaTituloCapitalizacao",
    descricao: "Bloco exibido somente quando a garantia da proposta é Título de Capitalização",
    exemplo: "inativa",
  },
  { categoria: "Proposta / Contrato", condicao: "TemBoleto", descricao: "Bloco exibido somente quando a proposta tem Boleto = Sim", exemplo: "ativa" },
  {
    categoria: "Proposta / Contrato",
    condicao: "TemCondominio",
    descricao: 'Bloco exibido somente quando há cobrança de condomínio (Valor do Condomínio não é "não se aplica")',
    exemplo: "ativa",
  },
  {
    categoria: "Proposta / Contrato",
    condicao: "TemInternet",
    descricao: "Bloco exibido somente quando há cobrança de internet compartilhada",
    exemplo: "ativa",
  },
  {
    categoria: "Proposta / Contrato",
    condicao: "TemTotem",
    descricao: "Bloco exibido somente quando há cobrança pelo uso do totem compartilhado",
    exemplo: "ativa",
  },
  {
    categoria: "Proposta / Contrato",
    condicao: "TemCarencia",
    descricao: "Bloco exibido somente quando a proposta concede período de carência",
    exemplo: "ativa",
  },
  {
    categoria: "Proposta / Contrato",
    condicao: "TemDesconto",
    descricao: "Bloco exibido somente quando a proposta concede desconto no aluguel",
    exemplo: "ativa",
  },
  { categoria: "Locatária", condicao: "LocatariaPF", descricao: "Bloco exibido somente quando a locatária é pessoa física", exemplo: "ativa" },
  { categoria: "Locatária", condicao: "LocatariaPJ", descricao: "Bloco exibido somente quando a locatária é pessoa jurídica", exemplo: "inativa" },
  {
    categoria: "Locatária",
    condicao: "LocatariaCasado",
    descricao: "Bloco exibido somente quando a locatária (PF) é casada ou vive em união estável",
    exemplo: "inativa",
  },
  { categoria: "Locadora", condicao: "LocadoraPF", descricao: "Bloco exibido somente quando a locadora é pessoa física", exemplo: "ativa" },
  { categoria: "Locadora", condicao: "LocadoraPJ", descricao: "Bloco exibido somente quando a locadora é pessoa jurídica", exemplo: "inativa" },
  {
    categoria: "Locadora",
    condicao: "LocadoraCasado",
    descricao: "Bloco exibido somente quando a locadora (PF) é casada ou vive em união estável",
    exemplo: "inativa",
  },
  { categoria: "Fiador", condicao: "FiadorPF", descricao: "Bloco exibido somente quando o fiador é pessoa física", exemplo: "ativa" },
  { categoria: "Fiador", condicao: "FiadorPJ", descricao: "Bloco exibido somente quando o fiador é pessoa jurídica", exemplo: "inativa" },
  {
    categoria: "Fiador",
    condicao: "FiadorCasado",
    descricao: "Bloco exibido somente quando o fiador (PF) é casado ou vive em união estável",
    exemplo: "inativa",
  },
  {
    categoria: "Seguradora",
    condicao: "SeguradoraCasado",
    descricao: "Bloco exibido somente quando a seguradora (PF, caso excepcional) é casada ou vive em união estável",
    exemplo: "inativa",
  },
];

export const TAGS_BLOCOS_TABELA_TEMPLATE_CONTRATO = [
  {
    categoria: "Proposta / Contrato",
    bloco: "QuadroResumo",
    descricao:
      'Insere a mesma tabela "QUADRO RESUMO" exibida na impressão da Proposta (Locadora, Locatário, imóvel, valores, prazos, garantia, Seguradora/Garantia Imobiliária quando aplicável)',
    uso: "[BLOCO:QuadroResumo]\n[/BLOCO:QuadroResumo]",
  },
];
